
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey-validasi-kompetensi-guru",
      function () {
        return require("private-next-pages/survey-validasi-kompetensi-guru/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey-validasi-kompetensi-guru"])
      });
    }
  